export const defaulView = {
  id: null,
  title: '默认视图',
  layouts: {
    elements: [
      {
        type: 'unboxing',
        elements: [
          {
            type: 'list',
            actionType: 'listConfig',
          },
        ],
      },
      {
        type: 'unboxing',
        rightElements: [
          {
            type: 'pagination',
          },
        ],
      },
    ],
  },

  operatorConfig: {
    elements: [
      {
        type: 'linkButton',
        actionType: 'detailConfig',
      },
      {
        type: 'linkButton',
        actionType: 'editorConfig',
      },
      {
        type: 'linkButton',
        actionType: 'deleteConfig',
      },
    ],
  },
  filters: {},
  viewType: 'list',
  tbId: null,
}

// 需判断要创建默认视图的类型，目前写死list
export const createDefaultView = (tbId) => {
  return { ...defaulView, tbId, id: Math.round(Math.random() * 100) }
}
